import { useDispatch, useSelector } from "../../../redux/hooks";
import { setURNHistoryModalData } from "../../../redux/slices/generatorFeaturesSlice";
import EntriesModal from "../EntriesModal/EntriesModal";

const URNHistoryModal = () => {
  const dispatch = useDispatch();
  const { URNHistoryModalData } = useSelector(
    state => state.generatorFeaturesSlice,
  );
  const handleClose = () => {
    dispatch(setURNHistoryModalData(null));
  };
  const title = `URN History for ${URNHistoryModalData?.userName ?? "URN " + URNHistoryModalData?.urn}`;

  return (
    <EntriesModal
      data={URNHistoryModalData?.data}
      title={title}
      onClose={handleClose}
      isNormalEntries={true}
    />
  );
};
export default URNHistoryModal;
